import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MultiSelectOption } from '../../multi-select/interfaces/multi-select-opts';
import { MasterService } from 'src/app/pages/master/master.service';

@Component({
  selector: 'app-modal-change-uses',
  templateUrl: './modal-change-uses.component.html',
})
export class ModalChangeUsesComponent implements OnInit {
  @Input() modalTitle: string = '';
  @Input() modalQuestion: string = '';
  @Input() modalMessage: string = '';
  @Input() entityName: string = '';
  @Input() attributeForm: FormGroup = new FormGroup({});
  @Output() modalDismissed: EventEmitter<string> = new EventEmitter<string>();
  @Output() modalClosed: EventEmitter<string> = new EventEmitter<string>();

  multiOpts: MultiSelectOption[] = [];
  readonly master: any = {};

  constructor(private masterService: MasterService) {
    this.master = this.masterService.getMaster();
  }

  ngOnInit(): void {
    this.multiOpts = this.master[this.entityName.toUpperCase() + '#USES'];
  }

  get usesControl(): FormControl<string[]> {
    return this.attributeForm.get('uses') as FormControl<string[]>;
  }

  /**
   * Función de desecho del modal.
   * @param {string} value Tecla con que fue desechado.
   */
  d(value: string): void {
    this.modalDismissed.emit(value);
  }

  /**
   * Función de cierre del modal.
   * @param {string} value Tecla con que fue cerrado.
   */
  c(value: string): void {
    this.modalClosed.emit(value);
  }
}
